import React, { useState } from 'react';
import { Grid, Tooltip } from "@mui/material";
import {
    BreadCrumbs,
    PageTitleWithToolTip,
    AddButton,
    DeleteModal,
    DataGrid
} from "../../Common";
import CreateIcon from '@mui/icons-material/Create';

import Routes from '../../../routes';
import toast from 'react-hot-toast';
import DeleteIcon from '@mui/icons-material/Delete';
import RegistrationTypeModal from './RegistrationTypeModal';
import { text_commonCellProps } from "../../Common/DataGrid/utils";
import { Grey2 } from "../../../color_utils";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";

const ManageLocationRegistration = () => {
    const [refreshNeeded, setRefreshNeeded] = useState(false);
    const [actionModal, setActionModal] = useState("");
    const [modalPayload, setModalPayload] = useState(null);

    const columns = [
        {
            field: 'name',
            headerName: 'Registration type',
            ...text_commonCellProps,
            filterable: false,
        },
        {
            field: 'renewalPeriodDays',
            headerName: 'Renewal period (days)',
            ...text_commonCellProps,
            filterable: false,
        },
        {
            field: 'instanceName',
            headerName: 'Accounts',
            ...text_commonCellProps,
            filterable: false,
        },
        {
            type: 'actions',
            field: 'Quick Actions',
            width: 100,
            getActions: ({ row: { id, name, renewalPeriodDays, instanceID } }) => [
                <GridActionsCellItem
                    icon={
                        <Tooltip
                            title="Edit Registration Type"
                        >
                            <CreateIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => {
                        setModalPayload({
                            id,
                            name,
                            renewalPeriodDays,
                            instanceID,
                        });
                        setActionModal('Edit');
                    }}
                />,
                <GridActionsCellItem
                    icon={
                        <Tooltip
                            title="Delete Registration Type"
                        >
                            <DeleteIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => {
                        setModalPayload({
                            id,
                            name,
                            renewalPeriodDays,
                            instanceID,
                        });
                        setActionModal('Delete');
                    }}
                />
            ]
        },
    ];

    const deleteRegistrationType = async () => {
        try {
            const response = await fetch(Routes.Location.DeleteLocationRegistrationType(modalPayload.id), {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                toast.success('The Registration Type has been successfully deleted.', { duration: 6000 });
                setRefreshNeeded(!refreshNeeded);
            }
            setActionModal("");
        } catch (error) {
            toast.error('Error Deleting Registration type', { duration: 6000 });
        }
    };

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: 'Geek Command Center', to: `/GeekCommandCenter` },
                    { text: 'Manage Location Registration' }
                ]}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
            >
                <Grid item xs={6} md={6} lg={6} mb={2}>
                    <PageTitleWithToolTip
                        pageTitle="Manage Location Registration Types"
                        toolTipText="Manage location registration types, so you can enable users to select a specific location registration type."
                    />
                </Grid>
                <Grid item xs={6} md={6} lg={6} align="right">
                    <AddButton
                        text="CREATE REGISTRATION TYPE"
                        onClick={() => {
                            setActionModal("Create");
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={12} lg={12} mt={4}>
                    <DataGrid
                        hideExportButton={true}
                        hideFilterButton={true}
                        url={Routes.Location.GetLocationRegistrationType()}
                        noResultText="Oops... It's empty here..."
                        refresh={refreshNeeded}
                        columns={columns}
                    />
                </Grid>

            </Grid>

            {(actionModal === 'Create' || actionModal === 'Edit') && (
                <RegistrationTypeModal
                    payload={actionModal === "Edit" ? modalPayload : null}
                    modalOpen={actionModal === "Create" || actionModal === "Edit"}
                    onClose={() => setActionModal("")}
                    refreshRequired={() => setRefreshNeeded(!refreshNeeded)}
                />
            )}

            {(actionModal === 'Delete' || actionModal === 'Edit') && (
                <DeleteModal
                    open={actionModal === "Delete"}
                    buttonText={"Yes, Delete"}
                    title="Are you sure you want to permanently delete this registration type?"
                    onClose={() => setActionModal("")}
                    onConfirm={deleteRegistrationType}
                    showImage={false}
                    renderCloseIcon={false}
                />
            )}
            
        </>
    );
};

export default ManageLocationRegistration;
